import { createAction } from '@reduxjs/toolkit';

export const addCategories = {
	request: createAction('categories/add/request'),
	success: createAction('categories/add/success'),
	error: createAction('categories/add/error')
};
